import { axios as axiosPol } from '../../plugins/axios-pol'
import { axios as axiosNormal } from '../../plugins/axios'

export default {
  namespaced: true,

  state: {
    sedes: [],
  },

  getters: {
    getSedes: (state) => {
      return state.sedes
    },
  },

  mutations: {
    SET_SEDES(state, sedes) {
      state.sedes = sedes
    },
  },

  actions: {
    fetchSedes: async function ({ commit }) {
      await axiosNormal
        .get('/EonCloud/common/sedes')
        .then((response) => {
          commit('SET_SEDES', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    fetchSedesByRegion: async function ({ commit }, region) {
      await axiosNormal
        .get('/EonCloud/common/regiones/' + region.id + '/sedes')
        .then((response) => {
          commit('SET_SEDES', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    fetchPersonalBySede: async function ({ commit }, { pageNumber, rowsOfPage, idSede }) {
      try {
        const response = await axiosPol.get(
          `/personal/api/EstadoFuerza/personal/page/${pageNumber}/rowsOfPage/${rowsOfPage}/sede/${idSede}`
        )

        const personalData =
          typeof response.data.data === 'string' ? JSON.parse(response.data.data) : response.data.data

        return {
          ...response.data,
          data: personalData,
        }
      } catch (error) {
        console.error('Error al obtener personal por sede:', error)
        throw error
      }
    },

    fetchPersonalBySubSede: async function ({ commit }, { pageNumber, rowsOfPage, idSubSede }) {
      try {
        const response = await axiosPol.get(
          `/personal/api/EstadoFuerza/personal/page/${pageNumber}/rowsOfPage/${rowsOfPage}/subsede/${idSubSede}`
        )

        const personalData =
          typeof response.data.data === 'string' ? JSON.parse(response.data.data) : response.data.data

        return {
          ...response.data,
          data: personalData,
        }
      } catch (error) {
        console.error('Error al obtener personal por subsede:', error)
        throw error
      }
    },
  },
}
